export { default } from './PaginationBlock';



// WEBPACK FOOTER //
// ./src/components/Common/Pagination/PaginationBlock/index.js